const config = {
    apiKey: process.env.GATSBY_FIREBASE_WEB_API_KEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
}

let firebaseInstance
let pendingAuth
let pendingToken
let pendingShop

export const getFirebase = async (firebase, customToken, shop) => {
    if (!config.apiKey || !config.authDomain || !config.projectId) {
        throw Object.assign(new Error('Firebase configuration is incomplete'), { code: 'auth/missing-config' })
    }
    if (!customToken || !shop) {
        throw Object.assign(new Error('Missing shop sign-in credentials'), { code: 'auth/invalid-custom-token' })
    }
    if (!firebaseInstance) {
        if (!firebase.apps.length) firebase.initializeApp(config)
        firebaseInstance = firebase
    }
    if (pendingAuth && pendingToken === customToken && pendingShop === shop) return pendingAuth

    pendingToken = customToken
    pendingShop = shop
    pendingAuth = (async () => {
        const auth = firebaseInstance.auth()
        // Embedded Shopify pages must not depend on third-party browser storage.
        await auth.setPersistence(firebase.auth.Auth.Persistence.NONE)
        const { user } = await auth.signInWithCustomToken(customToken)
        if (user.uid !== shop) {
            await auth.signOut()
            throw Object.assign(new Error('Shop does not match authenticated user'), { code: 'auth/shop-mismatch' })
        }
        return { firebase: firebaseInstance, user }
    })()
    try {
        return await pendingAuth
    } catch (error) {
        pendingAuth = null
        throw error
    }
}
